// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9840) return "js/9840-7aaf56995b72664b6732.chunk.js";
	if (chunkId === 8097) return "js/8097-ca45edc5be68d2c935b8.chunk.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"2476":"c97d3ebe11ded2fd037c","2893":"ce358d5b8262212220c2","5267":"b84222370dc0bbc3d9db","5353":"c10b9ec30e95f70f6db3","5718":"f43a40364bf6959950b1","9327":"07873dd351b181761d96","9961":"4b2c627d1ef5a315e9cc"}[chunkId] + ".js";
};